// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sr_a bhn_rc bhn_qx bhn_xr","ForumPosts__contest":"sr_b bhn_hq","ForumPosts__counselling":"sr_c"};